/**
 * @module Print
 */

import {actionWrapper} from '../helper';
import {Group, MetaAction} from '../types';
import {invalidActionType, ErrorAction} from '../Error';
import {ActionType} from './types';

export type PrintAction = MetaAction;

export function app(): PrintAction {
  return actionWrapper({
    group: Group.Print,
    type: ActionType.APP,
  });
}

export function validationError(action: MetaAction): undefined | ErrorAction {
  switch (action.type) {
    case ActionType.APP:
      // No validation since there should not be a payload
      return undefined;
    default:
      return invalidActionType(action);
  }
}



// WEBPACK FOOTER //
// ./src/actions/Print/actions.ts